<template>
  <main-layout>
    <div>
      <users-list :client="company"></users-list>
    </div>
  </main-layout>
</template>

<script>
import { mapState } from 'vuex';
import MainLayout from '@/views/settings/MainLayout.vue';
import UsersList from '@/views/settings/UsersList.vue';

export default {
  data: () => ({
  }),
  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
  },
  components: {
    MainLayout,
    UsersList,
  },
};
</script>
